import React from "react";
import { useNavigate } from "react-router-dom";
import { LOGO_WIDE } from "./Logo";
import { Button } from "./ui/button";
import { LogOut, Settings as SettingsIcon, ShieldCheck, ShieldAlert, Home, UploadCloud, Users } from "lucide-react";
import { clearToken } from "../lib/api";

/** Dark Presidential-Blue header bar with bright Sentry logo. */
export default function BrandHeader({ children, showSettings = false, showLogout = true, showAuditLog = false, showSecurityEvents = false, showAdmin = false, showImport = false, showClients = false, onLogoClick }) {
  const nav = useNavigate();
  const logout = () => { clearToken(); nav("/login"); };
  return (
    <header className="sticky top-0 z-30 shadow-md" style={{ background: "#0F1644" }} data-testid="brand-header">
      <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between gap-4">
        <button onClick={onLogoClick || (() => nav("/admin"))} className="flex items-center hover:opacity-90 transition" data-testid="brand-header-logo-btn">
          <img src={LOGO_WIDE} alt="Sentry Cloud IT" style={{ height: 64, width: "auto" }}/>
        </button>
        <div className="flex items-center gap-2">
          {children}
          {showAdmin && (
            <Button variant="ghost" onClick={() => nav("/admin")} className="text-white/80 hover:text-white hover:bg-white/10" data-testid="nav-admin-btn">
              <Home size={16} className="mr-2"/>Dashboard
            </Button>
          )}
          {showClients && (
            <Button variant="ghost" onClick={() => nav("/admin/clients")} className="text-white/80 hover:text-white hover:bg-white/10" data-testid="nav-clients-btn">
              <Users size={16} className="mr-2"/>Clients
            </Button>
          )}
          {showImport && (
            <Button variant="ghost" onClick={() => nav("/admin/import-itglue")} className="text-white/80 hover:text-white hover:bg-white/10" data-testid="nav-import-itglue-btn">
              <UploadCloud size={16} className="mr-2"/>Import
            </Button>
          )}
          {showSecurityEvents && (
            <Button variant="ghost" onClick={() => nav("/admin/security-events")} className="text-white/80 hover:text-white hover:bg-white/10" data-testid="nav-security-events-btn">
              <ShieldAlert size={16} className="mr-2"/>Security
            </Button>
          )}
          {showAuditLog && (
            <Button variant="ghost" onClick={() => nav("/admin/audit-log")} className="text-white/80 hover:text-white hover:bg-white/10" data-testid="nav-audit-log-btn">
              <ShieldCheck size={16} className="mr-2"/>Audit log
            </Button>
          )}
          {showSettings && (
            <Button variant="ghost" onClick={() => nav("/admin/settings")} className="text-white/80 hover:text-white hover:bg-white/10" data-testid="nav-settings-btn">
              <SettingsIcon size={16} className="mr-2"/>Settings
            </Button>
          )}
          {showLogout && (
            <Button variant="ghost" onClick={logout} className="text-white/80 hover:text-white hover:bg-white/10" data-testid="logout-btn">
              <LogOut size={16} className="mr-2"/>Sign out
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
